/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import cx from 'classnames';
import {
  Button,
  ContentLoader,
  Icon,
  Input,
  LabelWrapper } from
'../../../../../../ui-kit';
import '../styles/_keywords-field.scss';









const KeywordField = ({
  isDisabled,
  keywords,
  isKeywordsLoading,
  onChangeKeywords,
  onRegenerateKeywords,
  isKeywordGenerating
}) =>
<div className="context-keywords">
    <LabelWrapper className="context-keywords__label" label="Keywords">
      {isKeywordsLoading ?
    <div
      style={{
        border: '1px solid rgb(212, 217, 226)',
        borderRadius: '4px'
      }}>

          <ContentLoader
        height={70}
        width={200}
        preserveAspectRatio="xMinYMid meet">

            <rect x="10" y="15" width="180" height="5" rx="10" ry="10" />
            <rect x="10" y="30" width="180" height="5" rx="10" ry="10" />
            <rect x="10" y="45" width="180" height="5" rx="10" ry="10" />
            <rect x="10" y="60" width="180" height="5" rx="10" ry="10" />
            <rect x="10" y="75" width="180" height="5" rx="10" ry="10" />
          </ContentLoader>
        </div> :

    <div className="context-keywords__box">
          <Input
        disabled={isDisabled}
        multiline
        className={cx('context-keywords--input-regenerate', {
          'context-keywords--input-regenerate--button-visible': !!onRegenerateKeywords
        })}
        placeholder="E.g. Corporate, Social Responsibility, Environment"
        value={keywords}
        defaultValue={keywords}
        onChange={onChangeKeywords}
        rows={3} />

          {onRegenerateKeywords && !isDisabled &&
      <Button
        className="context-keywords__regenerate"
        onClick={onRegenerateKeywords}
        disabled={isKeywordGenerating}>

              <Icon
          color="purple"
          className="context-keywords__regenerate--icon"
          spin={isKeywordGenerating}
          size={15}
          name="sync2" />

              <p className="context-keywords__regenerate--text">Regenerate</p>
            </Button>}

        </div>}

    </LabelWrapper>
  </div>;


KeywordField.defaultProps = {
  isDisabled: false,
  isKeywordGenerating: false,
  isKeywordsLoading: false
};

export default KeywordField;